import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const Blogs = () => {
  useEffect(() => {
    // Scroll to the banner section on page load
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <section id="center" class="center_o bg-black p_3">
        <div class="container-xl">
          <div class="row center_o1">
            <div class="col-md-12">
              <h2 class="text-white">Blog</h2>
              <h6 class="mb-0 mt-3 col_yell">
                <a class="text-white" href="#">
                  Home
                </a>{" "}
                <span class="mx-2 text-muted">/</span> Blog{" "}
              </h6>
            </div>
          </div>
        </div>
      </section>

      <section id="blog" class="p_3">
        <div class="container-xl">
          <div class="row blog_1">
            <div class="col-md-8">
              <div class="blog_1l">
                <div class="story_1 row">
                  <div class="col-md-6">
                    <div class="story_1l shadow_box p-2">
                      <div class="story_1l1 position-relative">
                        <div class="story_1l1i">
                          <div class="grid clearfix">
                            <figure class="effect-jazz mb-0">
                              <Link to="/blog-Details4">
                                <img
                                  src="https://img.freepik.com/free-photo/html-css-collage-concept-with-person_23-2150061993.jpg"
                                  class="w-100"
                                  alt="abc"
                                />
                              </Link>
                            </figure>
                          </div>
                        </div>
                        <div class="story_1l1i1 position-absolute text-end w-100 px-3">
                          <img
                            src="./assets/img/asad.jpg"
                            class="rounded-circle"
                            width="60"
                            height="60"
                            alt="abc"
                          />
                        </div>
                      </div>
                      <div class="story_1l mt-4 px-3 pb-3">
                        <h6 class="fw-bold col_yell">Data Engineering</h6>
                        <h5 class="mt-3">
                          <Link to="/blog-Details4">
                            Navigating the Data Deluge: The Power of Data
                            Engineering
                          </Link>
                        </h5>
                        <p>
                          In the digital age, data is not just a commodity; it's
                          a strategic asset. Every click, swipe, and transaction
                          generates
                        </p>
                        <h6 class="mb-0 font_14">
                          <i class="fa fa-calendar col_yell me-1"></i> 15
                          February 2023{" "}
                          <i class="fa fa-user col_yell me-1 ms-3"></i>Md Asaduzzaman
                        </h6>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="story_1l shadow_box p-2">
                      <div class="story_1l1 position-relative">
                        <div class="story_1l1i">
                          <div class="grid clearfix">
                            <Link to="/blog-Details">
                              <img
                                src="https://img.freepik.com/free-photo/engineers-brainstorming-ways-use-ai_482257-84889.jpg"
                                className="w-100"
                                alt="abc"
                              />
                            </Link>
                          </div>
                        </div>
                        <div class="story_1l1i1 position-absolute text-end w-100 px-3">
                          <img
                            src="./assets/img/hridoy.jpeg"
                            class="rounded-circle"
                            width="60"
                            height="60"
                            alt="abc"
                          />
                        </div>
                      </div>
                      <div class="story_1l mt-4 px-3 pb-3">
                        <h6 class="fw-bold col_yell">
                          AI and Machine Learning
                        </h6>
                        <h5 class="mt-3">
                          <Link to="/blog-Details">
                            Revolutionizing Data Analytics with AI and Machine
                            Learning
                          </Link>
                        </h5>
                        <p>
                          AI and ML are transforming data analytics with smarter
                          insights and faster decisions, shaping the future of
                          innovation.
                        </p>
                        <h6 class="mb-0 font_14">
                          <i class="fa fa-calendar col_yell me-1"></i> 25 May
                          2024 <i class="fa fa-user col_yell me-1 ms-3"></i>
                          KH Hridoy
                        </h6>
                      </div>
                    </div>
                  </div>

                  {/* <div class="col-md-6">
				 <div class="story_1l shadow_box p-2">
				   <div class="story_1l1 position-relative">
					 <div class="story_1l1i">
						<div class="grid clearfix">
							  <figure class="effect-jazz mb-0">
								<a href="blog_detail.html"><img src="./assets/img/22.jpg" class="w-100" alt="abc"/></a>
							  </figure>
						  </div>
					 </div>
					 <div class="story_1l1i1 position-absolute text-end w-100 px-3">
					   <img src="./assets/img/8.jpg" class="rounded-circle" width="60" height="60" alt="abc"/>
					 </div>
				   </div>
					<div class="story_1l mt-4 px-3 pb-3">
					  <h6 class="fw-bold col_yell">BRIDE & BRIDESMAIDS</h6>
					  <h5 class="mt-3"><a href="blog_detail.html">23 Super-Chic Blazer Dresses for Your</a></h5>
					  <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy </p>
					  <h6 class="mb-0 font_14"><i class="fa fa-calendar col_yell me-1"></i> 23 February 2023 <i class="fa fa-user col_yell me-1 ms-3"></i> By Admin</h6>
					</div>
				 </div>
			   </div> */}
                  {/* <div class="col-md-6">
				 <div class="story_1l shadow_box p-2">
				   <div class="story_1l1 position-relative">
					 <div class="story_1l1i">
						<div class="grid clearfix">
							  <figure class="effect-jazz mb-0">
								<a href="blog_detail.html"><img src="./assets/img/23.jpg" class="w-100" alt="abc"/></a>
							  </figure>
						  </div>
					 </div>
					 <div class="story_1l1i1 position-absolute text-end w-100 px-3">
					   <img src="./assets/img/9.jpg" class="rounded-circle" width="60" height="60" alt="abc"/>
					 </div>
				   </div>
					<div class="story_1l mt-4 px-3 pb-3">
					  <h6 class="fw-bold col_yell">RINGS & JEWELRY</h6>
					  <h5 class="mt-3"><a href="blog_detail.html">Fusce Eget Nulla Sed Dui Placerat Viverra</a></h5>
					  <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy </p>
					  <h6 class="mb-0 font_14"><i class="fa fa-calendar col_yell me-1"></i> 25 February 2023 <i class="fa fa-user col_yell me-1 ms-3"></i> By Admin</h6>
					</div>
				 </div>
			   </div> */}
                </div>
                <div class="story_1 row mt-4">
                  <div class="col-md-6">
                    <div class="story_1l shadow_box p-2">
                      <div class="story_1l1 position-relative">
                        <div class="story_1l1i">
                          <div class="grid clearfix">
                            <figure class="effect-jazz mb-0">
                              <Link to="/blog-Details2">
                                <img
                                  src="https://img.freepik.com/free-photo/asian-businesswoman-sitting-desk-office-studying-graphs-large-computer-screen_1098-20500.jpg"
                                  class="w-100"
                                  alt="abc"
                                />
                              </Link>
                            </figure>
                          </div>
                        </div>
                        <div class="story_1l1i1 position-absolute text-end w-100 px-3">
                          <img
                            src="./assets/img/noman.jpg"
                            class="rounded-circle"
                            width="60"
                            height="60"
                            alt="abc"
                          />
                        </div>
                      </div>
                      <div class="story_1l mt-4 px-3 pb-3">
                        <h6 class="fw-bold col_yell">Data Analytics</h6>
                        <h5 class="mt-3">
                          <Link to="/blog-Details2">
                            The Power of Data Visualization: Unveiling Insights
                            Beyond Numbers
                          </Link>
                        </h5>
                        <p>
                          In the age of information overload, data has become
                          the lifeblood of decision-making and problem-solving
                          in every industry.{" "}
                        </p>
                        <h6 class="mb-0 font_14">
                          <i class="fa fa-calendar col_yell me-1"></i> 11 March
                          2024 <i class="fa fa-user col_yell me-1 ms-3"></i>
                          Md Abdullah Al Noman
                        </h6>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="story_1l shadow_box p-2">
                      <div class="story_1l1 position-relative">
                        <div class="story_1l1i">
                          <div class="grid clearfix">
                            <figure class="effect-jazz mb-0">
                              <Link to="/blog-Details1">
                                <img
                                  src="https://img.freepik.com/free-photo/html-css-collage-concept-with-person_23-2150062008.jpg"
                                  class="w-100"
                                  alt="abc"
                                />
                              </Link>
                            </figure>
                          </div>
                        </div>
                        <div class="story_1l1i1 position-absolute text-end w-100 px-3">
                          <img
                            src="./assets/img/hridoy.jpeg"
                            class="rounded-circle"
                            width="60"
                            height="60"
                            alt="abc"
                          />
                        </div>
                      </div>
                      <div class="story_1l mt-4 px-3 pb-3">
                        <h6 class="fw-bold col_yell">Software Development</h6>
                        <h5 class="mt-3">
                          <Link to="/blog-Details1">
                            Web and App Development: The Crucial Role of
                            JavaScript
                          </Link>
                        </h5>
                        <p>
                          JavaScript drives dynamic web content and interactive
                          features, making it essential for both web and app
                          development.
                        </p>
                        <h6 class="mb-0 font_14">
                          <i class="fa fa-calendar col_yell me-1"></i> 19 April
                          2023 <i class="fa fa-user col_yell me-1 ms-3"></i>
                          KH Hridoy
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="blog_1r">
                <div className="blog_1r1 shadow_box p-4">
                  <h4 className="mb-3">Categories</h4>
                  <h6>
                    <Link to="#">
                      <i className="fa fa-chevron-right col_yell me-1 font_12"></i>
                      Data Analytics
                    </Link>
                  </h6>
                  <hr />
                  <h6>
                    <Link to="#">
                      <i className="fa fa-chevron-right col_yell me-1 font_12"></i>
                      Artificial Intelligence
                    </Link>
                  </h6>
                  <hr />
                  <h6>
                    <Link to="#">
                      <i className="fa fa-chevron-right col_yell me-1 font_12"></i>
                      Machine Learning
                    </Link>
                  </h6>
                  <hr />
                  <h6>
                    <Link to="#">
                      <i className="fa fa-chevron-right col_yell me-1 font_12"></i>
                      Cloud Computing
                    </Link>
                  </h6>
                  <hr />
                  <h6 className="mb-0">
                    <Link to="#">
                      <i className="fa fa-chevron-right col_yell me-1 font_12"></i>
                      Business Intelligence
                    </Link>
                  </h6>
                </div>

                <div class="blog_1r1 shadow_box p-4 mt-4">
                  <h4 class="mb-3">Recent Post</h4>

                  <div class="blog_1r1i row">
                    <div class="col-md-4  col-4">
                      <div class="blog_1r1il">
                        <div class="grid clearfix">
                          <figure class="effect-jazz mb-0">
                            <Link to="/blog-Details">
                              <img
                                src="https://img.freepik.com/free-photo/engineers-brainstorming-ways-use-ai_482257-84889.jpg"
                                class="w-100"
                                alt="abc"
                              />
                            </Link>
                          </figure>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-8 col-8">
                      <div class="blog_1r1ir">
                        <h6>
                          <Link to="/blog-Details">
                            Revolutionizing Data Analytics with AI and Machine
                            Learning
                          </Link>
                        </h6>
                        <h6 class="text-muted font_14 fw-normal mb-0">
                          <i class="fa fa-clock-o col_yell me-1"></i> 25 May,
                          2024 <i class="fa fa-comment col_yell me-1 ms-2"></i>{" "}
                          4 Comments
                        </h6>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div class="blog_1r1i row">
                    <div class="col-md-4  col-4">
                      <div class="blog_1r1il">
                        <div class="grid clearfix">
                          <figure class="effect-jazz mb-0">
                            <Link to="/blog-Details2">
                              <img
                                src="https://img.freepik.com/free-photo/asian-businesswoman-sitting-desk-office-studying-graphs-large-computer-screen_1098-20500.jpg"
                                class="w-100"
                                alt="abc"
                              />
                            </Link>
                          </figure>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-8 col-8">
                      <div class="blog_1r1ir">
                        <h6>
                          <Link to="/blog-Details2">
                            The Power of Data Visualization: Unveiling Insights
                            Beyond Numbers
                          </Link>
                        </h6>
                        <h6 class="text-muted font_14 fw-normal mb-0">
                          <i class="fa fa-clock-o col_yell me-1"></i> 11 March,
                          2024 <i class="fa fa-comment col_yell me-1 ms-2"></i>{" "}
                          3 Comments
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="blog_1r1 shadow_box p-4 mt-4">
                  <h4 class="mb-3">Tags</h4>
                  <ul className="mb-0 tags">
                    <li className="d-inline-block">
                      <Link to="#">Data Analytics</Link>
                    </li>
                    <li className="d-inline-block">
                      <Link to="#">Artificial Intelligence</Link>
                    </li>
                    <li className="d-inline-block">
                      <Link to="#">Machine Learning</Link>
                    </li>
                    <li className="d-inline-block">
                      <Link to="#">Data Science</Link>
                    </li>
                    <li className="d-inline-block">
                      <Link to="#">Cloud Computing</Link>
                    </li>
                    <li className="d-inline-block">
                      <Link to="#">Big Data</Link>
                    </li>
                  </ul>
                </div>

                {/* <div class="blog_1r1 shadow_box p-4 mt-4">
                  <h4 class="mb-3">Newsletter</h4>
                  <p class="center_sm">Sign Up for Our Newsletter!</p>
                  <input
                    class="form-control"
                    placeholder="Subscribe"
                    type="text"
                  />
                  <h6 class="mb-0 mt-3 center_sm">
                    <a class="button" href="blog_detail.html">
                      Subscribe
                    </a>
                  </h6>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Blogs;
